import { Exception } from "go-core/api/types";
import { SubReportApi } from "go-report/core/services/types";

export type CompareFormatReportComboApi = "PERCENT" | "VALUE" | "GROWTH";
export type TypeReportComboApi = "CALCULATE" | "DIVIDER";
export interface KpisConfigReportComboApi {
	kpis: ConfigReportComboApi[];
}

export interface ConfigReportComboApi {
	id: string;
	name: string;
	description?: string;
	variables?: VariableConfigReportComboApi[];
	data: DataConfigReportComboApi[];
	rows?: RowConfigReportComboApi[];
	columns?: ColumnConfigReportComboApi[];
	table?: TableConfigReportComboApi[];
}
export interface VariableConfigReportComboApi {
	id: string;
	type?: "DYNAMIC" | "WEEK" | "QUARTER" | "MONTH";
	calculate?: VariableCalculateConfigReportComboApi;
}
export interface VariableCalculateConfigReportComboApi {
	method: string;
	variable_id: string;
	value?: number;
}

export interface DataConfigReportComboApi {
	id: string;
	resource: string;
	resource_url?: string;
	filter: string;
	groups: string[];
	columns: DataColumnConfigReportComboApi[];
}

export interface DataColumnConfigReportComboApi {
	id: string;
	filter: string;
	group?: string;
	compare?: DataColumnCompareConfigReportComboApi;
}

export interface DataColumnCompareConfigReportComboApi {
	filter: string;
}

export interface RowConfigReportComboApi {
	id: string;
	data_id?: string;
	data_ids?: string[];
	name: string;
	group?: string;
	group_values?: string[];
	aggregate?: string;
	aggregate_columns?: Record<string, string>;
	compare?: RowCompareConfigReportComboApi[];
	type?: TypeReportComboApi;
}

export interface TableConfigReportComboApi {
	id: string;
	name?: string;
	description?: string;
	rows: RowConfigReportComboApi[];
	columns: ColumnConfigReportComboApi[];
}
export interface RowCompareConfigReportComboApi {
	id: string;
	data_id?: string;
	name: string;
	aggregate?: string;
	aggregate_columns?: Record<string, string>;
	format: CompareFormatReportComboApi;
	type?: TypeReportComboApi;
}

export interface ColumnConfigReportComboApi {
	id: string;
	data_column_id: string;
	name: string;
	values_dynamic?: string;
	values?: ColumnConfigValueReportComboApi[];
	format?: CompareFormatReportComboApi;
	url_options?: ColumnConfigUrlOptionReportComboApi;
	styles?: ColumnConfigStyleReportComboApi;
	custom_format?: ColumnConfigFormatReportComboApi;
}
export interface ColumnConfigStyleReportComboApi {
	percent_color: boolean;
}
export interface ColumnConfigFormatReportComboApi {
	precision: number;
	locale: string;
}
export interface ColumnConfigValueReportComboApi {
	id: string;
	name?: string;
}
export interface ColumnConfigUrlOptionReportComboApi {
	groups?: string[];
}

export interface ResponseReportComboApi {
	id: string;
	name: string;
	reports: ReportResponseReportComboApi[];
}

export interface ReportResponseReportComboApi {
	id: string;
	resource: string;
	column_id: string;
	data: SubReportApi;
	compare_data: SubReportApi;
}

export interface FlatReportComboApi {
	id: string;
	name: string;
	description: string;
	config_table: TableConfigReportComboApi;
	columns?: ColumnConfigReportComboApi[];
	results?: ResultFlatReportComboApi[];
}

export interface ResultFlatReportComboApi {
	data_id: string;
	row_id: string;
	name: string;
	sub_report?: ResultFlatReportComboApi[];
	data: ResultDataFlatReportComboApi[];
}

export interface ResultDataFlatReportComboApi {
	id: string;
	column_id: string;
	data_column_id: string;
	aggregate: Record<string, string>;
	value: any;
	compare?: ResultDataCompareFlatReportComboApi[];
}

export interface ResultDataCompareFlatReportComboApi {
	compare_id: string;
	aggregate: Record<string, string>;
	value: any;
}

export class ValidationReportComboException extends Error implements Exception {
	constructor(message: string) {
		super(`Validation Error: ${message}`);
	}
}
